module.exports = __webpack_public_path__ + "img/poster3.jpg.202cb2ef.webp";